import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MethodSelectorEvents {
  public selectTakeaway: EventEmitter<boolean> = new EventEmitter(false);
  public selectDelivery: EventEmitter<boolean> = new EventEmitter(false);
}
